<template>
  <div id="subtaskList">
    <div v-show="!onChild">
      <table-title slot="title">筛选栏</table-title>
      <Form ref="formValidates" :model="queryParams" inline :label-width="100">
        <!-- <FormItem label="发货方">
          <dict-select namespace="bizObjects" id="member" :exclusion="[]" v-model="queryParams.fromMemberId" />
        </FormItem>
        <FormItem label="收货方">
          <dict-select namespace="bizObjects" id="member" :exclusion="[]" v-model="queryParams.toMemberId" />
        </FormItem> -->
        <FormItem label="状态">
          <dict-select namespace="ENUM_MID-OPERATE-LOGISTICS" id="logisticSubTask.logiSubTaskStatus" :includes="['IN_TRANSIT','FINISH']" v-model="queryParams.status" />
        </FormItem>
        <FormItem label="创建时间">
          <DatePicker type="daterange" placeholder="请选择" split-panels :editable="false" @on-change="onCreateTime" style="width:200px"></DatePicker>
        </FormItem>
        <!-- <FormItem label="发货仓库">
          <dict-select namespace="bizObjects" id="warehouse" :exclusion="[]" v-model="queryParams.fromWarehouseId" />
        </FormItem> -->
        <!-- <FormItem label="收货仓库">
          <dict-select namespace="bizObjects" id="warehouse" :exclusion="[]" v-model="queryParams.toWarehouseId" />
        </FormItem> -->
        <FormItem label="收货仓库">
          <bizSelect v-model="queryParams.toWarehouseId" codeField="storageId" textField="storageName" url="http://MID-OPERATE-LOGISTICS/messageService/queryService/queryManagerStorageInfo" style="width:200px" />
        </FormItem>
        <FormItem label="标的物小类">
          <target-type-cascader :width="200" @onTargetType="onTargetType" v-model="queryParams.targetSubClassCode" />
        </FormItem>
        <FormItem label="标的物编码">
          <Select v-model="queryParams.targetCode" filterable clearable style="width:200px">
            <Option v-for="item in targetCodeList" :value="item.code" :key="item.code">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <!-- <FormItem label="出库时间">
          <DatePicker type="daterange" placeholder="请选择" split-panels :editable="false" @on-change="onshippingDate" style="width:200px"></DatePicker>
        </FormItem> -->
        <FormItem label="接收时间">
          <DatePicker type="daterange" placeholder="请选择" split-panels :editable="false" @on-change="onreceiveDate" style="width:200px"></DatePicker>
        </FormItem>
        <FormItem label="物流任务编号">
          <Input v-model="queryParams.logisticTaskId" placeholder="物流任务编号" clearable style="width: 200px" />
        </FormItem>
        <FormItem label="运单编号">
          <Input v-model="queryParams.waybillId" placeholder="运单编号" clearable style="width: 200px" />
        </FormItem>

        <FormItem label="物流子任务号">
          <Input v-model="queryParams.logisticSubTaskId" placeholder="物流子任务号" clearable style="width: 200px" />
        </FormItem>
        <!-- <FormItem label="参与人分组">
          <dict-select namespace="bizObjects" id="memberGroup" :exclusion="[]" v-model="queryParams.groupId" />
        </FormItem> -->
        <!-- <FormItem label="发货数量">
          <InputNumber v-model="queryParams.shippingAmount" style="width: 200px" />
        </FormItem> -->
        <!-- <FormItem label="计划出库日期">
          <DatePicker type="daterange" placeholder="请选择" split-panels :editable="false" @on-change="onPlanShippingDate" style="width:200px"></DatePicker>
        </FormItem> -->
        <FormItem label="发货地址">
          <Input v-model="queryParams.fromAddr" clearable style="width: 200px" placeholder="请输入" />
        </FormItem>
        <Button type="primary" style="margin-left:20px" @click="search">查询</Button>
      </Form>
      <table-title>物流子任务列表</table-title>
      <data-grid ref="lg" :columns="cols" :queryParams="queryParams" paramsName="param" :queryUrl="queryUrl" subListName>
        <template #default="{columns, data}">
          <Table :columns="columns" :data="data" border stripe size="small" style="margin:10px">
            <!-- <template slot-scope="{row}" slot="logisticTaskId">
              <a href="javascript:;" class="hoverCollection" style="color:#2D8CF0" @click="queryLogistics(row.logisticTaskId)">{{row.logisticTaskId}}</a>
            </template> -->
            <template #shippingNoteId="{row}">
              <a href="javascript:;" class="hoverCollection" style="color: #2d8cf0;padding:5px" v-if="row.shippingNoteId" @click="toRecord(row.shippingNoteId)">{{row.shippingNoteId?'查看附件':""}}</a>
            </template>
            <template #receiveNoteId="{row}">
              <a href="javascript:;" class="hoverCollection" style="color: #2d8cf0;padding:5px" v-if="row.receiveNoteId" @click="toRecord(row.receiveNoteId)">{{row.receiveNoteId?'查看附件':""}}</a>
              <a href="javascript:;" class="hoverCollection" style="color: #F90;padding:5px" v-if="row.status === 'FINISH'" @click="onBackhander(row.logisticSubTaskId)">追加附件</a>
            </template>
            <template #eReceiveNoteId="{row}">
              <a href="javascript:;" class="hoverCollection" style="color: #2d8cf0;padding:5px" v-if="row.eReceiveNoteId" @click="checkEnote(row)">{{getEReceiptNoteText(row)}}</a>
              <span v-else>未上传</span>
            </template>
            <template slot-scope="{row}" slot="status">
              <Tag color="gold" v-show="row.status === 'PENDING'">待出库</Tag>
              <Tag color="gold" v-show="row.status === 'IN_TRANSIT'">在途</Tag>
              <Tag color="blue" v-show="row.status === 'FINISH'">结束</Tag>
              <Tag color="red" v-show="row.status === 'CANCEL'">取消</Tag>
            </template>
            <template slot-scope="{row}" slot="operation">
              <Button type="primary" v-show="row.status === 'PENDING' && row.waybillId" size="small" @click="goStorage(row)">出库确认</Button>
              <!-- <Button type="error" v-show="row.status === 'PENDING' && !row.waybillId" style="margin-left:5px" size="small" @click="cancel(row)">取消</Button> -->
              <Button type="success" v-show="row.status === 'IN_TRANSIT'" style="margin-left:5px" size="small" @click="settleAffirm(row)">了结确认</Button>
              <!-- <Button type="info" v-show="row.isTransferStartRent" style="margin-left:5px" size="small" @click="onExport('物流起租单','startRentDoc',row)">导出起租单</Button>
              <Button type="info" v-show="row.isTransferTerminateRent" style="margin-left:5px" size="small" @click="onExport('物流退租单','terminateRentDoc',row)">导出退租单</Button>
              <Button type="info" v-show="row.isTransferSale" style="margin:5px 0 0 5px" size="small" @click="onExportSell('物流签收单','salesReceiptShenzhenDoc',row.logisticSubTaskId)">导出销售签收单</Button>
              <Button v-if="row.isTransferStartRent || row.isTransferTerminateRent || row.isTransferSale" @click="checkReceipts(row)" style="margin:5px 0 0 5px" size="small">查看电子签收单</Button>
              <Button type="primary" ghost v-show="row.isTransferAdjust" style="margin:5px 0 0 5px" size="small" @click="onExportAdjust('调仓单',row)">导出调仓单</Button> -->
            </template>
          </Table>
        </template>
      </data-grid>
      <to-record ref="toRecordRef" />
      <upload-adjunct ref="uploadAdjunctRef" />
      <export-pdf ref="exportPdfRef" />
    </div>
    <div v-if="onChild">
      <component v-bind:is="currentChild" :data="currentRow" @on-finish="onFinish"></component>
    </div>

  </div>
</template>

<script>
// import { saveFile } from "@/libs/utils/localUtil.js";

import tableTitle from "@/components/tableTitle/tableTitle.vue";
import dataGrid from "@/components/datagrid.vue";
import dictSelect from "@/components/select/dict-select.vue";
import addrCascader from "@/components/select/addr-cascader.vue";
import targetTypeCascader from "@/components/select/targetType-cascader";
import bizSelect from "@/components/select/biz-select.vue";
import goStorage from "./goStorage.vue";
import settleAffirm from "./settleAffirm.vue";
import logisticsDetail from "@/views/logistics/logisticsList/logisticsDetail";
import toRecord from "@/components/toRecord.vue";
import uploadAdjunct from "./component/uploadAdjunct";
// import exportPdf from "_v/trade/deliveryPlan/component/export-pdf";

import { mapState } from "vuex";
export default {
  name: "subtaskList",
  components: {
    tableTitle,
    dataGrid,
    dictSelect,
    addrCascader,
    targetTypeCascader,
    goStorage,
    settleAffirm,
    logisticsDetail,
    toRecord,
    uploadAdjunct,
    // exportPdf,
    bizSelect,
  },
  data() {
    return {
      queryParams: {
        waybillId: "",
        logisticSubTaskId: "",
        logisticTaskId: "",
        fromMemberId: "",
        toAreaId: "",
        fromWarehouseId: "",
        toWarehouseId: "",
        toMemberId: "",
        targetSubClassCode: "",
        targetCode: "",
        status: "",
        createDateBegin: "",
        createDateEnd: "",
        shippingDateBegin: "",
        shippingDateEnd: "",
        receiveDateBegin: "",
        receiveDateEnd: "",
        shippingAmount: "",
      },
      time: "",
      productRemark: "", //调仓导出备注 2021-07-27
      currentChild: "",
      currentRow: {}, //传递参数
      onChild: false,
      queryUrl:
        "MID-OPERATE-LOGISTICS/messageService/queryService/queryStorageInManage",
      // 标的物编码
      targetCodeList: [],
      cols: [
        { title: "运单编号", key: "waybillId", fixed: "left", width: 100 },
        { title: "物流任务编号", key: "logisticTaskId", width: 100 },
        { title: "物流子任务编号", key: "logisticSubTaskId", width: 100 },
        {
          title: "标的物小类",
          key: "targetSubClassCode",
          dict: ["target", "type", true],
          width: 100,
        },
        {
          title: "收货方",
          key: "toMemberId",
          dict: ["bizObjects", "member", true],
          width: 100,
        },
        { title: "计划数量", key: "planQty", width: 60 },
        { title: "出库数量", key: "shippingQty", width: 60 },
        // {
        //   title: "计划出库日期",
        //   key: "planShippingDate",
        //   formatter: "date",
        //   width: 100,
        // },
        // {
        //   title: "出库时间",
        //   key: "shippingDate",
        //   formatter: "date",
        //   width: 100,
        // },
        { title: "接收数量", key: "receiveQty", width: 60 },
        {
          title: "接收时间",
          key: "receiveDate",
          formatter: "date",
          width: 100,
        },
        { title: "退回数量", key: "returnQty", width: 60 },
        { title: "丢失数量", key: "lossQty", width: 60 },
        { title: "退回时间", key: "returnDate", formatter: "date", width: 100 },
        {
          title: "司机名称",
          key: "driverId",
          dict: ["bizObjects", "contact", true],
          width: 100,
        },
        {
          title: "发货仓库",
          key: "fromWarehouseId",
          dict: ["bizObjects", "warehouse", true],
          width: 100,
        },
        {
          title: "发货方",
          key: "fromMemberId",
          dict: ["bizObjects", "member", true],
          width: 150,
        },
        {
          title: "收货仓库",
          key: "toWarehouseId",
          dict: ["bizObjects", "warehouse", true],
          width: 100,
        },
        {
          title: "标的物编码",
          key: "targetCode",
          dict: ["target", "targetCodeUnion", true],
          width: 100,
        },
        // { title: "出库确认附件", slot: "shippingNoteId", width: 110 },
        { title: "了结确认附件", slot: "receiveNoteId", width: 130 },
        // { title: "电子签收单", slot: "eReceiveNoteId", width: 80 },
        { title: "状态", slot: "status", width: 70 },
        {
          title: "发货省市区",
          key: "fromAreaId",
          dict: ["region", "fullArea", true],
          width: 200,
        },
        {
          title: "发货地址",
          key: "fromAddr",
          width: 200,
        },
        {
          title: "源业务类型",
          key: "souceBizCode",
          dict: ["logistic", "logisticTaskCallback"],
          width: 80,
        },
        // { title: "成本分配比例", key: "costRatio", width: 100 },
        { title: "创建时间", key: "createTime", formatter: "date", width: 100 },
        { title: "操作", slot: "operation", fixed: "right", width: 200 },
      ],
    };
  },
  // watch: {
  //   $route(to, from) {
  //     this.$refs["lg"].queryData();
  //   },
  // },
  computed: {
    // ...mapState("logisticsStore", {
    //   queryParams: (state) => state.logisticsSubTaskQueryParams,
    // }),
  },
  activated() {
    this.$refs["lg"].queryData();
  },
  methods: {
    // 计划出库日期
    onPlanShippingDate(val) {
      this.queryParams.planShippingDateBegin = val[0];
      this.queryParams.planShippingDateEnd = val[1];
    },
    // 模板选择导出pdf
    onExportSell(fileName, exportId, row) {
      this.$refs["exportPdfRef"].openModal(fileName, exportId, row);
    },
    // 导出pdf
    async onExport(fileName, exportId, row) {
      let params = {
        exportId: exportId,
        body: {
          logisticSubTaskId: row.logisticSubTaskId,
        },
      };
      await this.pltUtil.showConfirm("操作提示", `确定要导出${fileName}吗？`);
      let res = await this.request("/exportPDF", params, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        responseType: "arraybuffer",
      });
      if (res) {
        saveFile(fileName + ".pdf", res);
      }
    },
    // 导出调仓单
    onExportAdjust(fileName, row) {
      let params = {
        exportId: "adjustDoc",
        body: {
          logisticSubTaskId: row.logisticSubTaskId,
        },
      };
      this.$Modal.confirm({
        title: `确定要导出${fileName}吗？`,
        render: (h) => {
          return h("Input", {
            props: {
              value: this.productRemark,
              autofocus: true,
              type: "textarea",
              placeholder: "备注",
            },
            on: {
              input: (val) => {
                this.productRemark = val;
              },
            },
          });
        },
        onOk: async () => {
          params.body.productRemark = this.productRemark;
          let res = await this.request("/exportPDF", params, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            responseType: "arraybuffer",
          });
          if (res) {
            saveFile(fileName + ".pdf", res);
          }
        },
        onCancel: () => {
          this.productRemark = "";
        },
      });
    },
    // 查看下载附件
    toRecord(id) {
      this.$refs["toRecordRef"].lookFile(id);
    },
    // 追加附件
    onBackhander(id) {
      this.$refs["uploadAdjunctRef"].openModal(id);
    },
    search() {
      this.$refs["lg"].loadFirstPage();
    },
    onFinish() {
      this.$refs["lg"].queryData();
      this.onChild = false;
    },
    onTargetType(params) {
      this.queryParams.targetSubClassCode = params;
      if (params) this.getTargetCode(params);
    },
    queryLogistics(logisticTaskId) {
      this.onChild = true;
      this.currentChild = logisticsDetail;
      this.currentRow = logisticTaskId;
    },
    async getTargetCode(targetType) {
      let data = {
        url: "http://CORE-TARGET/messageService/leaseTargetService/queryAllTargetCodesUnionByType",
        body: {
          targetType: targetType,
        },
      };
      this.targetCodeList = await this.invoke(data);
    },
    // 省市区
    onAddrCascader(params) {
      this.queryParams.toAreaId = params;
    },
    // 创建时间
    onCreateTime(val) {
      this.queryParams.createDateBegin = val[0];
      this.queryParams.createDateEnd = val[1];
    },
    // 运送时间
    onshippingDate(val) {
      this.queryParams.shippingDateBegin = val[0];
      this.queryParams.shippingDateEnd = val[1];
    },
    // 接收时间
    onreceiveDate(val) {
      this.queryParams.receiveDateBegin = val[0];
      this.queryParams.receiveDateEnd = val[1];
    },

    goStorage(row) {
      this.currentChild = goStorage;
      this.onChild = true;
      this.currentRow = row;
    },
    // 取消
    cancel(row) {
      this.$Modal.confirm({
        title: "确定要取消该物流子任务吗?",
        onOk: () => {
          let data = {
            url: "MID-OPERATE-LOGISTICS/messageService/logisticSubTaskService/cancelLogiSubTask",
            body: { subTaskId: row.logisticSubTaskId },
          };
          this.invoke(data).then((res) => {
            this.$Message.success("物流子任务取消成功");
            this.search();
          });
        },
      });
    },
    settleAffirm(row) {
      // this.currentChild = settleAffirm
      // this.currentRow = row
      // this.onChild = true
      this.$router.push({
        path: "/user-center/storage/putInSettleAffirm",
        query: { task: JSON.stringify(row) },
      });
      console.log(row);
    },
    checkReceipts(row) {
      this.$router.push({
        path: "/home/logistics/e-receipts",
        query: { task: JSON.stringify(row) },
      });
    },
    getEReceiptNoteText(row) {
      return row.eReceiveNoteId?.length ? "查看" : "未上传";
    },
    checkEnote(row) {
      let query = {
        businessNo: row.logisticSubTaskId,
        backPath: "/home/logistics/subtaskList",
      };
      this.$router.push({ path: "/home/logistics/e-receipt-notes", query });
    },
  },
};
</script>
<style lang="scss"  scoped>
.hoverCollection:hover {
  text-decoration: underline;
}
</style>